import { render, staticRenderFns } from "./uploadPictures.vue?vue&type=template&id=22221e32&scoped=true&"
import script from "./uploadPictures.vue?vue&type=script&lang=js&"
export * from "./uploadPictures.vue?vue&type=script&lang=js&"
import style0 from "./uploadPictures.vue?vue&type=style&index=0&id=22221e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22221e32",
  null
  
)

export default component.exports